// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__fI9_q","inner":"Footer_inner__8z3yC"};